import React, { lazy } from "react";
import { Route } from "react-router";

import { RouteGuardApplicationRights } from "components/routes/RouteGuardApplicationRights";
import { LazyRouteElement } from "components/routes/LazyRouteElement";
import Layout from "components/layout/Layout";
import { Module } from "./Module";
import { DecisionWriteRight } from "./Rights";

const IndexLazy = lazy(() => import("./pages/Index").then(module => ({ default: module.Index })));
const RecommendationIndexLazy = lazy(() => import("./pages/recommendation/Index").then(module => ({ default: module.Index })));
const DecisionIndexLazy = lazy(() => import("./pages/decision/Index").then(module => ({ default: module.Index })));

export function Routes() {
    return (
        <>
            <Route
                key="exemption-applications-index"
                path="/exemption-applications"
                element={
                    <Layout>
                        <RouteGuardApplicationRights requiredApplicationRights={Module.applicationRights}>
                            <LazyRouteElement fallback={null}>{<IndexLazy />}</LazyRouteElement>
                        </RouteGuardApplicationRights>
                    </Layout>
                }
            />

            <Route
                key="exemption-applications-id-index"
                path="/exemption-applications/:id"
                element={
                    <Layout>
                        <RouteGuardApplicationRights requiredApplicationRights={Module.applicationRights}>
                            <LazyRouteElement fallback={null}>{<IndexLazy />}</LazyRouteElement>
                        </RouteGuardApplicationRights>
                    </Layout>
                }
            />

            <Route
                key="exemption-applications-recommendation-index"
                path="/exemption-applications/:id/recommendation"
                element={
                    <Layout>
                        <RouteGuardApplicationRights requiredApplicationRights={Module.applicationRights}>
                            <LazyRouteElement fallback={null}>{<RecommendationIndexLazy />}</LazyRouteElement>
                        </RouteGuardApplicationRights>
                    </Layout>
                }
            />

            <Route
                key="exemption-applications-decision-index"
                path="/exemption-applications/:id/decision"
                element={
                    <Layout>
                        <RouteGuardApplicationRights requiredApplicationRights={[DecisionWriteRight]}>
                            <LazyRouteElement fallback={null}>{<DecisionIndexLazy />}</LazyRouteElement>
                        </RouteGuardApplicationRights>
                    </Layout>
                }
            /> 
        </> 
    )
}
